import { ROUTE_TYPES } from '@wareclouds/frontend-common/b2c';
import { REGIONAL_HUB_ROUTE_TYPE } from '../../../../routes/utils/routeTypes';
import { ToReceiveCrossdockingView } from '../../ui/views';
import { ToReceiveDefaultView } from '../../ui/views';

export const crossdockingToReceiveRouteTypes = [
  ROUTE_TYPES.CROSSDOCKING,
  REGIONAL_HUB_ROUTE_TYPE,
];

const toReceiveViewFactory = {
  [ROUTE_TYPES.CROSSDOCKING]: ToReceiveCrossdockingView,
  [REGIONAL_HUB_ROUTE_TYPE]: ToReceiveCrossdockingView,
  [ROUTE_TYPES.SAME_DAY]: ToReceiveDefaultView,
  [ROUTE_TYPES.EXPRESS_SCHEDULED]: ToReceiveDefaultView,
  [ROUTE_TYPES.EXPRESS]: ToReceiveDefaultView,
  DEFAULT: ToReceiveDefaultView,
};

export default toReceiveViewFactory;
